import StructurePopupHtml from "./StructurePopupHtml.js";

export default class StructurePopupCmp {
    /** @type {StructurePopupHtml} */
    #html;
    constructor() {
        this.#html = new StructurePopupHtml();
    }


    /**
     * @param {HTMLElement} hoverElement
     */
    init(hoverElement) {
        this.#html.init(hoverElement);
    }

    /**
     *
     * @param {string} svgLink
     */
    show(svgLink) {
        this.#html.show(svgLink);
    }
    remove() {
        this.#html.remove();
    }
}